import React from 'react';
import Skeleton from 'react-loading-skeleton';
import { localeStore } from 'src/mobx/localesStore';
import { ICurrencySettings } from 'src/types/app';
import { IOrderProduct, IOrderProductModifier } from 'src/types/orders';
import { formatPrice, getTranslate } from 'src/utils/formatter';
import Accordion from 'src/view/components/Controls/Accordion/Accordion';
import Donation from 'src/view/components/Tooltip/Donation/Donation';
import { OrderItem } from '../OrderItem/OrderItem';
import { OrderModifier } from '../OrderModifier/OrderModifier';
import { OrderNotes } from '../OrderNotes/OrderNotes';
import './style.scss';

interface IProps {
  product?: IOrderProduct;
  currency_settings?: ICurrencySettings;
}

export const Product: React.FC<IProps> = ({ product, currency_settings }: IProps) => {
  if (!product) {
    return (
      <div className="details-product-container">
        <Skeleton height={69} />
      </div>
    );
  }

  const haveModifiers: boolean = Boolean(!product.type && product.modifiers?.length);
  const haveItems: boolean = Boolean(product.type && product.items?.length);
  const size: IOrderProduct['size'] = product.size;
  const product_title: string = `${getTranslate(product.name)} ${size ? ` (${getTranslate(size.name)}) ` : ''}`;

  return (
    <div className="details-product-container">
      <Accordion
        trigger={() => (
          <div className={`details-product ${haveModifiers || haveItems ? 'with-modifiers' : ''}`}>
            <div className="details-product-data background-light">
              <div className="details-product-name">{product_title}</div>
              <div className="details-product-quantity ml-2">{product.quantity}</div>
            </div>
            <div className="details-product-price ml-4">
              {formatPrice(
                (size ? size.price : product.price) * product.quantity,
                currency_settings?.currency,
                currency_settings?.currency_position
              )}
            </div>
          </div>
        )}
      >
        {haveModifiers
          ? product.modifiers.map((modifier: IOrderProductModifier) => (
              <OrderModifier key={modifier.id} modifier={modifier} productQuantity={product.quantity} />
            ))
          : null}
        {haveItems ? product.items?.map((item) => <OrderItem key={item.id} item={item} />) : null}
        {product.notes ? <OrderNotes notes={product.notes} /> : null}
      </Accordion>
      {product.is_donation ? (
        <div className="mr-3 d-flex flex-row align-items-center">
          <Donation />
          <p className="color-dark text-size-12 ml-3">{localeStore.t('cart_donation_info')}</p>
        </div>
      ) : null}
    </div>
  );
};
